import ajax from '@/utils/ajax';

const header = '/web';
// 获取推荐产品接口（产品详情页-满减）
// eslint-disable-next-line import/prefer-default-export
export const reqGetGroupDetail = (data) => ajax(`${header}/v1/group/detail`, data, 'GET');
// 获取用户拼团中的团数据
export const reqGetGroupProcessing = (data) => ajax(`${header}/v1/group/processing`, data, 'GET');
// 拼团校验接口
export const reqPostGroupCheck = (data) => ajax(`${header}/v1/group/check`, data, 'POST');
